import { useState } from "react";
import { Upload, File as FileIcon, Loader2, X, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export function FileUpload({ docType = "document", label, onUploaded, files = [], onRemove }) {
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("doc_type", docType);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded?.(data);
      toast.success(`${data.filename} uploaded`);
    } catch { toast.error("Upload failed"); }
    finally { setUploading(false); e.target.value = ""; }
  };

  return (
    <div>
      {label && <p className="mb-1 text-xs font-medium text-slate-500">{label}</p>}
      <label className="flex cursor-pointer items-center justify-center gap-2 rounded-xl border border-dashed border-slate-300 p-4 text-sm text-slate-500 transition hover:border-brand hover:bg-brand-light" data-testid={`upload-${docType}`}>
        {uploading ? <Loader2 size={18} className="animate-spin text-brand" /> : <Upload size={18} className="text-slate-400" />}
        <span>{uploading ? "Uploading…" : "Click to upload (image or PDF, max 12MB)"}</span>
        <input type="file" accept="image/*,application/pdf" className="hidden" onChange={handle} disabled={uploading} />
      </label>
      {files.length > 0 && (
        <div className="mt-2 space-y-1.5">
          {files.map((f) => (
            <div key={f.id} className="flex items-center justify-between rounded-lg bg-slate-50 px-3 py-2 text-sm" data-testid={`file-${f.id}`}>
              <span className="flex min-w-0 items-center gap-2"><CheckCircle2 size={14} className="shrink-0 text-emerald-500" /><FileIcon size={13} className="shrink-0 text-slate-400" /><span className="truncate text-slate-700">{f.filename}</span><span className="shrink-0 text-xs text-slate-400">· {f.doc_type}</span></span>
              {onRemove && <button onClick={() => onRemove(f.id)} className="text-slate-400 hover:text-red-500"><X size={15} /></button>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
